import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import ClipLoader from 'react-spinners/ClipLoader';
import { Controller } from 'react-hook-form';
import { isNotEmptyArray } from 'utils/misc';
import CancellationType from '../CancellationType';
import * as Styled from './FormLayout.styled';

const FormLayout = (props) => {
  const {
    children,
    onSubmit,
    cancellationReasons,
    formControl,
    isSubmittingForm,
    adfitNo,
    cancellationOptions,
    dataTestId,
  } = props;

  const history = useHistory();

  return (
    <div data-testid={dataTestId}>
      <Styled.Paper>
        <Styled.PaperHeader>
          <Styled.PaperHeaderText>{'Cancel Account'}</Styled.PaperHeaderText>
        </Styled.PaperHeader>
        <Styled.PaperBodyOverload loading={isSubmittingForm}>
          <Styled.InputWrapper>
            <CancellationType
              cancellationOptions={cancellationOptions}
              formControl={formControl}
            />
          </Styled.InputWrapper>
          {children}
          {isNotEmptyArray(cancellationReasons) && (
            <Styled.InputWrapper>
              <Controller
                name={'customCancelReason'}
                control={formControl}
                rules={{ required: false }}
                render={({ onChange }) => (
                  <Styled.CancelReasonDropdown
                    label={'Cancellation reason'}
                    options={cancellationReasons}
                    onChange={(selectedObject) =>
                      onChange(selectedObject ? selectedObject.value : null)
                    }
                    isSearchable={false}
                    isDisabled={isSubmittingForm}
                    isClearable={true}
                  />
                )}
              />
            </Styled.InputWrapper>
          )}
        </Styled.PaperBodyOverload>
      </Styled.Paper>
      <Styled.ActionButtonContainer>
        <Styled.ConfirmSubmissionButton
          variant={'error'}
          data-testid={'cancel-confirm-button'}
          type={'submit'}
          isDisabled={isSubmittingForm}
          onClick={onSubmit}
        >
          {isSubmittingForm ? (
            <>
              <Styled.LoadingConfirmTextContainer>
                {'Confirm'}
              </Styled.LoadingConfirmTextContainer>
              <ClipLoader
                color={'#FFFFFF'}
                size={18}
                css={{ marginLeft: '8px' }}
              />
            </>
          ) : (
            'Confirm'
          )}
        </Styled.ConfirmSubmissionButton>
        <Styled.BackButton
          variant={'slighter'}
          data-testid={'cancel-back-button'}
          isDisabled={isSubmittingForm}
          onClick={() => history.push(`/Customers/${adfitNo}/Overview`)}
          type={'none'}
        >
          {'Back'}
        </Styled.BackButton>
      </Styled.ActionButtonContainer>
    </div>
  );
};

FormLayout.InputWrapper = Styled.InputWrapper;

FormLayout.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  formControl: PropTypes.object.isRequired,
  cancellationReasons: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ),
  cancellationOptions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      subLabel: PropTypes.string,
      value: PropTypes.number,
    })
  ).isRequired,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
  isSubmittingForm: PropTypes.bool,
  adfitNo: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  dataTestId: PropTypes.string,
};

FormLayout.defaultProps = {
  isSubmittingForm: false,
  cancellationReasons: [],
  dataTestId: 'form-layout',
};

export default FormLayout;
